import { render } from "./Project-1.vue?vue&type=template&id=13465d7e"
import script from "./Project-1.vue?vue&type=script&lang=js"
export * from "./Project-1.vue?vue&type=script&lang=js"
script.render = render

export default script